goog.provide("shadow.js.shim.module$dayjs$plugin$quarterOfYear");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$quarterOfYear");
shadow.js.shim.module$dayjs$plugin$quarterOfYear = shadow.js.nativeProvides["dayjs/plugin/quarterOfYear"] = require("dayjs/plugin/quarterOfYear");
module$shadow_js_shim_module$dayjs$plugin$quarterOfYear.default = shadow.js.shim.module$dayjs$plugin$quarterOfYear;
